var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "group_buy_config",
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticStyle: { width: "70%" },
          attrs: { model: _vm.form, "label-width": "100px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "活动名称：" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入活动名称" },
                model: {
                  value: _vm.form.activityName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "activityName", $$v)
                  },
                  expression: "form.activityName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "点餐类型：", prop: "menuType" } },
            [
              _c(
                "el-checkbox-group",
                {
                  model: {
                    value: _vm.form.menuTypes,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "menuTypes", $$v)
                    },
                    expression: "form.menuTypes",
                  },
                },
                _vm._l(_vm.menuTypeList, function (item) {
                  return _c(
                    "el-checkbox",
                    { key: item.code, attrs: { label: item.code } },
                    [_vm._v("\n          " + _vm._s(item.desc) + "\n        ")]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "执行日期：", prop: "executeDateList" } },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "daterange",
                  format: "yyyy-MM-dd",
                  "value-format": "yyyy-MM-dd",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                },
                on: { change: _vm.changeValidDate },
                model: {
                  value: _vm.form.executeDateList,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "executeDateList", $$v)
                  },
                  expression: "form.executeDateList",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "有限时间：", prop: "executeTimeList" } },
            [
              _c("el-time-picker", {
                attrs: {
                  "is-range": "",
                  format: "HH:mm",
                  "value-format": "HH:mm",
                  "range-separator": "至",
                  "start-placeholder": "开始时间",
                  "end-placeholder": "结束时间",
                  placeholder: "选择时间范围",
                },
                on: { change: _vm.changeValidDate },
                model: {
                  value: _vm.form.executeTimeList,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "executeTimeList", $$v)
                  },
                  expression: "form.executeTimeList",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "关联商品：", prop: "relatedGoodsIdList" } },
            [
              _c("el-checkbox", {
                attrs: { label: "是否选择全部商品" },
                model: {
                  value: _vm.form.markAllGoods,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "markAllGoods", $$v)
                  },
                  expression: "form.markAllGoods",
                },
              }),
              _vm._v(" "),
              !_vm.form.markAllGoods
                ? _c(
                    "div",
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: {
                            width: "70%",
                            "margin-bottom": "10px",
                          },
                          attrs: {
                            filterable: "",
                            remote: "",
                            "reserve-keyword": "",
                            placeholder: "请搜索选项关联商品",
                            "remote-method": _vm.searchGoods,
                            loading: _vm.searchGoodsLoading,
                            "value-key": "goodsFnId",
                          },
                          model: {
                            value: _vm.checkedGoods,
                            callback: function ($$v) {
                              _vm.checkedGoods = $$v
                            },
                            expression: "checkedGoods",
                          },
                        },
                        _vm._l(_vm.goodsList, function (item) {
                          return _c(
                            "el-option",
                            {
                              key: item.goodsFnId,
                              attrs: { label: item.goodsName, value: item },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    "justify-content": "space-between",
                                  },
                                },
                                [
                                  _c("span", [_vm._v(_vm._s(item.goodsName))]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(item.goodsCode))]),
                                ]
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: { click: _vm.addGoods },
                        },
                        [_vm._v("\n          添加\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-table",
                        {
                          key: _vm.goodsTableKey,
                          staticStyle: { width: "70%" },
                          attrs: {
                            border: "",
                            data: _vm.form.checkedGoodsList,
                            size: "mini",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { prop: "goodsCode", label: "商品编号" },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { prop: "goodsName", label: "商品名称" },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "操作" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "text",
                                            size: "small",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.removeGoods(scope.row)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                移除\n              "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2635870772
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "优惠信息：", prop: "relatedGoodsIdList" } },
            [
              _c(
                "div",
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.thresholdType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "thresholdType", $$v)
                        },
                        expression: "form.thresholdType",
                      },
                    },
                    _vm._l(_vm.thresholdTypeList, function (item) {
                      return _c(
                        "el-radio",
                        { key: item.code, attrs: { label: item.code } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.desc) +
                              "\n          "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v("\n      满\n      "),
              _vm.form.thresholdType === "quantity"
                ? _c(
                    "span",
                    [
                      _vm.form.thresholdType === "quantity"
                        ? _c("el-input-number", {
                            attrs: { min: 0, precision: 0 },
                            model: {
                              value: _vm.form.thresholdQuantity,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "thresholdQuantity", $$v)
                              },
                              expression: "form.thresholdQuantity",
                            },
                          })
                        : _vm._e(),
                      _vm._v("\n        件，每件减\n      "),
                    ],
                    1
                  )
                : _vm.form.thresholdType === "user"
                ? _c(
                    "span",
                    [
                      _vm.form.thresholdType === "user"
                        ? _c("el-input-number", {
                            attrs: { min: 0, precision: 0 },
                            model: {
                              value: _vm.form.thresholdUser,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "thresholdUser", $$v)
                              },
                              expression: "form.thresholdUser",
                            },
                          })
                        : _vm._e(),
                      _vm._v("\n        人，每人减\n      "),
                    ],
                    1
                  )
                : _vm.form.thresholdType === "amount"
                ? _c(
                    "span",
                    [
                      _vm.form.thresholdType === "amount"
                        ? _c("el-input-number", {
                            attrs: { min: 0, precision: 2 },
                            model: {
                              value: _vm.form.thresholdAmount,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "thresholdAmount", $$v)
                              },
                              expression: "form.thresholdAmount",
                            },
                          })
                        : _vm._e(),
                      _vm._v("\n        元，减\n      "),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("el-input-number", {
                attrs: { min: 0, precision: 2 },
                model: {
                  value: _vm.form.discount,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "discount", $$v)
                  },
                  expression: "form.discount",
                },
              }),
              _vm._v("\n      元\n    "),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "活动规则：", prop: "activityDescribe" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 4,
                  autosize: { minRows: 4, maxRows: 6 },
                  placeholder: "请输入活动规则",
                  maxlength: 1000,
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.form.activityDescribe,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "activityDescribe", $$v)
                  },
                  expression: "form.activityDescribe",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "是否启用：", prop: "markForEnable" } },
            [
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.form.markForEnable,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "markForEnable", $$v)
                    },
                    expression: "form.markForEnable",
                  },
                },
                [_vm._v("\n        启用\n      ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "全部门店：", prop: "storeScope" } },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { "true-label": 0, "false-label": 1 },
                  model: {
                    value: _vm.form.storeScope,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "storeScope", $$v)
                    },
                    expression: "form.storeScope",
                  },
                },
                [_vm._v("\n        全部门店\n      ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.form.storeScope === 1
            ? _c(
                "el-form-item",
                { attrs: { label: "指定门店", prop: "relatedStoreIdList" } },
                _vm._l(_vm.regionStoreList, function (regionStore) {
                  return _c("region-store-pane", {
                    key: regionStore.regionId,
                    attrs: {
                      "region-store": regionStore,
                      "echo-store-ids": _vm.form.relatedStoreIdList,
                    },
                    on: { change: _vm.handleRegionStoreChange },
                  })
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.validDate },
                  on: { click: _vm.submitForm },
                },
                [_vm._v("\n        提交\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }